import _extends from "@babel/runtime/helpers/esm/extends";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useEffect, useState } from 'react';
import ImageLoader from '../../images/ImageLoader';
import { AuthenticationState } from 'react-aad-msal';
import { Button } from 'react-bootstrap';
import { RichText } from '@sitecore-jss/sitecore-jss-react';
import { connect } from 'react-redux';
import { LoyaltyAccountStatus } from '../../../util/LoyaltyAccountStatus';
import { getLoyaltyStorage } from '../../../util';
import FetchRewardOverlay from '../../cart/RewardRedemptionModule/FetchRewardOverlay';
import { rewardsDuck } from '../../../ducks/rewards';
import { mobilepayDuck } from '../../../ducks/mobilepay';
import { getSessionStorageKey } from '../../../util/sessionStorage';
import MPRewardSelectionModal from './MPRewardSelectionModal';
import { useFlags } from 'launchdarkly-react-client-sdk';
import moment from 'moment';

var MPRewardRedemptionModule = function MPRewardRedemptionModule(props) {
  var _Animation$, _RewardSelection$;

  // states: sign-in, redeem, no-rewards, no-eligible-rewards, recommended, custom, paused
  var _useState = useState('sign-in'),
      _useState2 = _slicedToArray(_useState, 2),
      moduleType = _useState2[0],
      setModuleType = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      rewardsList = _useState4[0],
      setRewardsList = _useState4[1]; //state to show fetch rewards overlay


  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      showOverlay = _useState6[0],
      setShowOverlay = _useState6[1]; //state to show reward selection modal


  var _useState7 = useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      showSelectionModal = _useState8[0],
      setShowSelectionModal = _useState8[1];

  var flags = useFlags();
  var releaseMobilePayRewardRedemptionRetail = flags['releaseMobilePayRewardRedemptionRetailDstr5238'] ? flags['releaseMobilePayRewardRedemptionRetailDstr5238'] : false;
  var releaseRedemptionEngineV2 = flags['releaseRedemptionEngineV2PromosDstr6078'] ? flags['releaseRedemptionEngineV2PromosDstr6078'] : false;
  var _props$model = props.model,
      model = _props$model === void 0 ? {} : _props$model,
      authenticationState = props.authenticationState,
      isSubmitting = props.isSubmitting;
  var Logo = model.Logo,
      SignInLink = model.SignInLink,
      NoRewardsAvailable = model.NoRewardsAvailable,
      RedeemButton = model.RedeemButton,
      RecommendedRewardsHeader = model.RecommendedRewardsHeader,
      AppliedRewardsHeader = model.AppliedRewardsHeader,
      RewardsLinkLabel = model.RewardsLinkLabel,
      RewardSelection = model.RewardSelection,
      Animation = model.Animation,
      PausedAccCopy = model.PausedAccCopy,
      NoEligibleRewards = model.NoEligibleRewards,
      _model$RewardBadge = model.RewardBadge,
      RewardBadge = _model$RewardBadge === void 0 ? null : _model$RewardBadge,
      _model$UnavailableRew = model.UnavailableRewardCopy,
      UnavailableRewardCopy = _model$UnavailableRew === void 0 ? null : _model$UnavailableRew;
  var loyaltyStorage = getLoyaltyStorage();
  useEffect(function () {
    _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _loyaltyStorage$accou;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(authenticationState !== AuthenticationState.Authenticated)) {
                _context.next = 6;
                break;
              }

              _context.next = 3;
              return props.resetCheck();

            case 3:
              setModuleType('sign-in');
              _context.next = 14;
              break;

            case 6:
              if (!((loyaltyStorage === null || loyaltyStorage === void 0 ? void 0 : (_loyaltyStorage$accou = loyaltyStorage.account) === null || _loyaltyStorage$accou === void 0 ? void 0 : _loyaltyStorage$accou.Status) === LoyaltyAccountStatus.Paused)) {
                _context.next = 12;
                break;
              }

              _context.next = 9;
              return props.resetCheck();

            case 9:
              setModuleType('paused');
              _context.next = 14;
              break;

            case 12:
              _context.next = 14;
              return getRecommendedRewards();

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  }, [releaseMobilePayRewardRedemptionRetail, props.account, releaseRedemptionEngineV2]);
  /**
   * Get rewards ids from rewards array
   * @param rewards
   * @returns []
   */

  var getRewards = function getRewards(rewards) {
    if (releaseRedemptionEngineV2) {
      return rewards.map(function (reward) {
        var _reward$fields, _reward$fields$Extern, _reward$fields2, _reward$fields2$Code, _reward$fields3, _reward$fields3$Expir;

        return {
          "rewardId": (_reward$fields = reward.fields) === null || _reward$fields === void 0 ? void 0 : (_reward$fields$Extern = _reward$fields.ExternalId) === null || _reward$fields$Extern === void 0 ? void 0 : _reward$fields$Extern.value,
          "couponCode": (_reward$fields2 = reward.fields) === null || _reward$fields2 === void 0 ? void 0 : (_reward$fields2$Code = _reward$fields2.Code) === null || _reward$fields2$Code === void 0 ? void 0 : _reward$fields2$Code.value,
          "expirationDate": moment((_reward$fields3 = reward.fields) === null || _reward$fields3 === void 0 ? void 0 : (_reward$fields3$Expir = _reward$fields3.Expiration) === null || _reward$fields3$Expir === void 0 ? void 0 : _reward$fields3$Expir.value).format('YYYY-MM-DD')
        };
      });
    } else {
      return rewards.map(function (reward) {
        var _reward$fields4, _reward$fields4$Exter;

        if ((_reward$fields4 = reward.fields) === null || _reward$fields4 === void 0 ? void 0 : (_reward$fields4$Exter = _reward$fields4.ExternalId) === null || _reward$fields4$Exter === void 0 ? void 0 : _reward$fields4$Exter.value) {
          return reward.fields.ExternalId.value;
        }
      });
    }
  };
  /**
   * Api call to get bonus rewards and peg points
   * @returns {Promise<{bonusRewards: [], pegPoints: string}>}
   */


  var getRewardsAndPoints = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var _response$;

      var response, filteredBonusRewards;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return Promise.all([props.getBonusRewards(releaseRedemptionEngineV2), props.getPegPoints(null, releaseRedemptionEngineV2)]);

            case 2:
              response = _context2.sent;
              filteredBonusRewards = response === null || response === void 0 ? void 0 : (_response$ = response[0]) === null || _response$ === void 0 ? void 0 : _response$.filter(function (reward) {
                var _reward$fields5, _reward$fields5$Exter, _reward$fields6, _reward$fields6$Exter, _reward$fields7, _reward$fields7$Code;

                return ((_reward$fields5 = reward.fields) === null || _reward$fields5 === void 0 ? void 0 : (_reward$fields5$Exter = _reward$fields5.ExternalId) === null || _reward$fields5$Exter === void 0 ? void 0 : _reward$fields5$Exter.value) && ((_reward$fields6 = reward.fields) === null || _reward$fields6 === void 0 ? void 0 : (_reward$fields6$Exter = _reward$fields6.ExternalId) === null || _reward$fields6$Exter === void 0 ? void 0 : _reward$fields6$Exter.value) !== '' && ((_reward$fields7 = reward.fields) === null || _reward$fields7 === void 0 ? void 0 : (_reward$fields7$Code = _reward$fields7.Code) === null || _reward$fields7$Code === void 0 ? void 0 : _reward$fields7$Code.value);
              });
              return _context2.abrupt("return", {
                bonusRewards: filteredBonusRewards || [],
                pegPoints: (response === null || response === void 0 ? void 0 : response[1]) || '0'
              });

            case 5:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function getRewardsAndPoints() {
      return _ref2.apply(this, arguments);
    };
  }();

  var getRedeemedRewardsList = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(redeemedRewards, bonusRewards) {
      var _bonusRewards, rewards;

      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (redeemedRewards) {
                _context3.next = 4;
                break;
              }

              setRewardsList(null);
              _context3.next = 18;
              break;

            case 4:
              rewards = [];

              if (bonusRewards) {
                _context3.next = 15;
                break;
              }

              _context3.prev = 6;
              _context3.next = 9;
              return props.getBonusRewards(releaseRedemptionEngineV2);

            case 9:
              bonusRewards = _context3.sent;
              _context3.next = 15;
              break;

            case 12:
              _context3.prev = 12;
              _context3.t0 = _context3["catch"](6);
              console.error('error', _context3.t0.message);

            case 15:
              (_bonusRewards = bonusRewards) === null || _bonusRewards === void 0 ? void 0 : _bonusRewards.forEach(function (reward) {
                var _redeemedRewards$rewa;

                if (redeemedRewards === null || redeemedRewards === void 0 ? void 0 : (_redeemedRewards$rewa = redeemedRewards.rewards) === null || _redeemedRewards$rewa === void 0 ? void 0 : _redeemedRewards$rewa.some(function (obj) {
                  return obj.code === reward.fields.Code.value;
                })) {
                  var _reward$fields8, _reward$fields8$Name, _reward$fields8$Name$;

                  rewards.push((_reward$fields8 = reward.fields) === null || _reward$fields8 === void 0 ? void 0 : (_reward$fields8$Name = _reward$fields8.Name) === null || _reward$fields8$Name === void 0 ? void 0 : (_reward$fields8$Name$ = _reward$fields8$Name.value) === null || _reward$fields8$Name$ === void 0 ? void 0 : _reward$fields8$Name$.trim());
                }
              });

              if (redeemedRewards.pegs) {
                rewards.push("".concat(redeemedRewards.pegs, " pegs"));
              }

              setRewardsList(rewards.join(', '));

            case 18:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[6, 12]]);
    }));

    return function getRedeemedRewardsList(_x, _x2) {
      return _ref3.apply(this, arguments);
    };
  }();

  var hideFetchOverlay = function hideFetchOverlay() {
    setShowOverlay(false);
  };

  var hideSelectionModal = function hideSelectionModal() {
    setShowSelectionModal(false);
  };

  var handleCustomizeLink = function handleCustomizeLink() {
    setShowSelectionModal(true);
  };

  var handleReset = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              setShowOverlay(true);
              _context4.prev = 1;
              _context4.next = 4;
              return props.resetRewardsRedemptionModule();

            case 4:
              _context4.next = 6;
              return props.orderValidate();

            case 6:
              setModuleType('redeem');
              _context4.next = 12;
              break;

            case 9:
              _context4.prev = 9;
              _context4.t0 = _context4["catch"](1);
              console.error('Error while resetting rewards', _context4.t0.message);

            case 12:
              setShowOverlay(false);

            case 13:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[1, 9]]);
    }));

    return function handleReset() {
      return _ref4.apply(this, arguments);
    };
  }();

  var updateRecommendedRewards = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
      var _yield$getRewardsAndP, bonusRewards, pegPoints, _rewardsRedemptionAPI, _rewardsRedemptionAPI2, _rewardsRedemptionAPI3, _rewardsRedemptionAPI4, _rewardsRedemptionAPI5, _rewardsRedemptionAPI6, rewardsRedemptionAPIResponse;

      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;
              _context5.next = 3;
              return getRewardsAndPoints();

            case 3:
              _yield$getRewardsAndP = _context5.sent;
              bonusRewards = _yield$getRewardsAndP.bonusRewards;
              pegPoints = _yield$getRewardsAndP.pegPoints;

              if (!(!bonusRewards.length && (!pegPoints || parseInt(pegPoints || 0) < 75))) {
                _context5.next = 11;
                break;
              }

              setModuleType('no-rewards');
              return _context5.abrupt("return", false);

            case 11:
              _context5.next = 13;
              return props.rewardsRedemptionMobilePay(getRewards(bonusRewards), pegPoints, 'recommended-options', releaseMobilePayRewardRedemptionRetail, releaseRedemptionEngineV2);

            case 13:
              rewardsRedemptionAPIResponse = _context5.sent;

              if (!(rewardsRedemptionAPIResponse === null || rewardsRedemptionAPIResponse === void 0 ? void 0 : (_rewardsRedemptionAPI = rewardsRedemptionAPIResponse.redeemOptions) === null || _rewardsRedemptionAPI === void 0 ? void 0 : (_rewardsRedemptionAPI2 = _rewardsRedemptionAPI[0]) === null || _rewardsRedemptionAPI2 === void 0 ? void 0 : (_rewardsRedemptionAPI3 = _rewardsRedemptionAPI2.cart) === null || _rewardsRedemptionAPI3 === void 0 ? void 0 : _rewardsRedemptionAPI3.length)) {
                setModuleType('no-eligible-rewards');
              }

              return _context5.abrupt("return", rewardsRedemptionAPIResponse === null || rewardsRedemptionAPIResponse === void 0 ? void 0 : (_rewardsRedemptionAPI4 = rewardsRedemptionAPIResponse.redeemOptions) === null || _rewardsRedemptionAPI4 === void 0 ? void 0 : (_rewardsRedemptionAPI5 = _rewardsRedemptionAPI4[0]) === null || _rewardsRedemptionAPI5 === void 0 ? void 0 : (_rewardsRedemptionAPI6 = _rewardsRedemptionAPI5.cart) === null || _rewardsRedemptionAPI6 === void 0 ? void 0 : _rewardsRedemptionAPI6.length);

            case 16:
              _context5.next = 21;
              break;

            case 18:
              _context5.prev = 18;
              _context5.t0 = _context5["catch"](0);
              console.error('Error updating recommended rewards', _context5.t0.message);

            case 21:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, null, [[0, 18]]);
    }));

    return function updateRecommendedRewards() {
      return _ref5.apply(this, arguments);
    };
  }();

  var getRecommendedRewards = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
      var _yield$getRewardsAndP2, bonusRewards, pegPoints, rewardsState, _rewardsState$redeeme, _rewardsState$redeeme2, _rewardsRedemptionAPI7, _rewardsRedemptionAPI8, _rewardsRedemptionAPI9, rewardsRedemptionAPIResponse, redeemedRewards;

      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.prev = 0;
              _context6.next = 3;
              return getRewardsAndPoints();

            case 3:
              _yield$getRewardsAndP2 = _context6.sent;
              bonusRewards = _yield$getRewardsAndP2.bonusRewards;
              pegPoints = _yield$getRewardsAndP2.pegPoints;

              if (!(!bonusRewards.length && (!pegPoints || parseInt(pegPoints || 0) < 75))) {
                _context6.next = 10;
                break;
              }

              setModuleType('no-rewards');
              _context6.next = 31;
              break;

            case 10:
              rewardsState = getSessionStorageKey('rewards');

              if (!(rewardsState === null || rewardsState === void 0 ? void 0 : rewardsState.redeemedRewards)) {
                _context6.next = 26;
                break;
              }

              if (!(rewardsState === null || rewardsState === void 0 ? void 0 : (_rewardsState$redeeme = rewardsState.redeemedRewards) === null || _rewardsState$redeeme === void 0 ? void 0 : _rewardsState$redeeme.checkout)) {
                _context6.next = 19;
                break;
              }

              _context6.next = 15;
              return handleReset();

            case 15:
              _context6.next = 17;
              return getRecommendedRewards();

            case 17:
              _context6.next = 24;
              break;

            case 19:
              _context6.next = 21;
              return updateRecommendedRewards();

            case 21:
              _context6.next = 23;
              return getRedeemedRewardsList((rewardsState === null || rewardsState === void 0 ? void 0 : rewardsState.redeemedRewards) || null, bonusRewards);

            case 23:
              setModuleType(rewardsState === null || rewardsState === void 0 ? void 0 : (_rewardsState$redeeme2 = rewardsState.redeemedRewards) === null || _rewardsState$redeeme2 === void 0 ? void 0 : _rewardsState$redeeme2.type);

            case 24:
              _context6.next = 31;
              break;

            case 26:
              _context6.next = 28;
              return props.rewardsRedemptionMobilePay(getRewards(bonusRewards), pegPoints, 'recommended-options', releaseMobilePayRewardRedemptionRetail, releaseRedemptionEngineV2);

            case 28:
              rewardsRedemptionAPIResponse = _context6.sent;
              redeemedRewards = (rewardsState === null || rewardsState === void 0 ? void 0 : rewardsState.redeemedRewards) || null;

              if (rewardsRedemptionAPIResponse === null || rewardsRedemptionAPIResponse === void 0 ? void 0 : (_rewardsRedemptionAPI7 = rewardsRedemptionAPIResponse.redeemOptions) === null || _rewardsRedemptionAPI7 === void 0 ? void 0 : (_rewardsRedemptionAPI8 = _rewardsRedemptionAPI7[0]) === null || _rewardsRedemptionAPI8 === void 0 ? void 0 : (_rewardsRedemptionAPI9 = _rewardsRedemptionAPI8.cart) === null || _rewardsRedemptionAPI9 === void 0 ? void 0 : _rewardsRedemptionAPI9.length) {
                if (!redeemedRewards) {
                  setModuleType('redeem');
                }
              } else {
                setModuleType('no-eligible-rewards');
              }

            case 31:
              _context6.next = 37;
              break;

            case 33:
              _context6.prev = 33;
              _context6.t0 = _context6["catch"](0);
              console.error('error', _context6.t0.message);
              setModuleType(null);

            case 37:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, null, [[0, 33]]);
    }));

    return function getRecommendedRewards() {
      return _ref6.apply(this, arguments);
    };
  }();
  /**
   * Handle redeem click
   * @returns {Promise<void>}
   */


  var handleRedeemClick = /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
      var _yield$getRewardsAndP3, bonusRewards, pegPoints, _rewardsRedemptionAPI10, _rewardsRedemptionAPI11, _rewardsRedemptionAPI12, rewardsRedemptionAPIResponse, redeemedRewards;

      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.prev = 0;
              _context7.next = 3;
              return getRewardsAndPoints();

            case 3:
              _yield$getRewardsAndP3 = _context7.sent;
              bonusRewards = _yield$getRewardsAndP3.bonusRewards;
              pegPoints = _yield$getRewardsAndP3.pegPoints;

              if (!(!bonusRewards.length && (!pegPoints || parseInt(pegPoints || 0) < 75))) {
                _context7.next = 10;
                break;
              }

              setModuleType('no-rewards');
              _context7.next = 27;
              break;

            case 10:
              _context7.next = 12;
              return props.rewardsRedemptionMobilePay(getRewards(bonusRewards), pegPoints, 'recommended', releaseMobilePayRewardRedemptionRetail, releaseRedemptionEngineV2);

            case 12:
              rewardsRedemptionAPIResponse = _context7.sent;
              _context7.next = 15;
              return props.redeemRewards('recommended', true, releaseMobilePayRewardRedemptionRetail, releaseRedemptionEngineV2);

            case 15:
              redeemedRewards = _context7.sent;
              _context7.next = 18;
              return props.storeRedeemedRewards(redeemedRewards || null);

            case 18:
              _context7.next = 20;
              return getRedeemedRewardsList(redeemedRewards || null, bonusRewards);

            case 20:
              if (rewardsRedemptionAPIResponse === null || rewardsRedemptionAPIResponse === void 0 ? void 0 : (_rewardsRedemptionAPI10 = rewardsRedemptionAPIResponse.redeemOptions) === null || _rewardsRedemptionAPI10 === void 0 ? void 0 : (_rewardsRedemptionAPI11 = _rewardsRedemptionAPI10[0]) === null || _rewardsRedemptionAPI11 === void 0 ? void 0 : (_rewardsRedemptionAPI12 = _rewardsRedemptionAPI11.cart) === null || _rewardsRedemptionAPI12 === void 0 ? void 0 : _rewardsRedemptionAPI12.length) {
                _context7.next = 24;
                break;
              }

              setModuleType('no-eligible-rewards');
              _context7.next = 27;
              break;

            case 24:
              _context7.next = 26;
              return props.orderValidate();

            case 26:
              setModuleType('recommended');

            case 27:
              setShowOverlay(false);
              _context7.next = 34;
              break;

            case 30:
              _context7.prev = 30;
              _context7.t0 = _context7["catch"](0);
              console.error('error', _context7.t0.message);
              setShowOverlay(false);

            case 34:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, null, [[0, 30]]);
    }));

    return function handleRedeemClick() {
      return _ref7.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FetchRewardOverlay, {
    show: showOverlay,
    hide: hideFetchOverlay,
    model: Animation === null || Animation === void 0 ? void 0 : (_Animation$ = Animation[0]) === null || _Animation$ === void 0 ? void 0 : _Animation$.fields
  }), (RewardSelection === null || RewardSelection === void 0 ? void 0 : (_RewardSelection$ = RewardSelection[0]) === null || _RewardSelection$ === void 0 ? void 0 : _RewardSelection$.fields) && /*#__PURE__*/React.createElement(MPRewardSelectionModal, _extends({}, props, {
    show: showSelectionModal,
    hide: hideSelectionModal,
    model: RewardSelection === null || RewardSelection === void 0 ? void 0 : RewardSelection[0].fields,
    moduleType: moduleType,
    setModuleType: setModuleType,
    getRedeemedRewardsList: getRedeemedRewardsList,
    releaseMobilePayRewardRedemptionRetail: releaseMobilePayRewardRedemptionRetail,
    releaseRedemptionEngineV2: releaseRedemptionEngineV2,
    rewardBadge: RewardBadge,
    unavailableRewardCopy: UnavailableRewardCopy
  })), /*#__PURE__*/React.createElement("div", {
    className: "cb-mobile-pay-reward-redemption-module type-".concat(moduleType)
  }, /*#__PURE__*/React.createElement("div", {
    className: "cb-mobile-pay-reward-redemption-module__logo-image-container ".concat(authenticationState !== AuthenticationState.Authenticated ? 'cb-mobile-pay-reward-redemption-module__logo-image-container--unauthenticated' : '')
  }, /*#__PURE__*/React.createElement(ImageLoader, {
    media: Logo,
    className: "cb-mobile-pay-reward-redemption-module__logo-image"
  })), /*#__PURE__*/React.createElement("div", {
    className: 'cb-mobile-pay-reward-redemption-module__redemption-component'
  }, authenticationState !== AuthenticationState.Authenticated && /*#__PURE__*/React.createElement("div", {
    className: 'cb-mobile-pay-reward-redemption-module__redemption-component__sing-in'
  }, /*#__PURE__*/React.createElement(RichText, {
    field: SignInLink,
    tag: 'div',
    className: 'cb-mobile-pay-reward-redemption-module__redemption-component__sing-in__rich-text-container'
  })), authenticationState === AuthenticationState.Authenticated ? /*#__PURE__*/React.createElement(React.Fragment, null, moduleType === 'paused' && /*#__PURE__*/React.createElement("div", {
    className: 'cb-mobile-pay-reward-redemption-module__redemption-component__paused'
  }, /*#__PURE__*/React.createElement("span", {
    className: 'cb-mobile-pay-reward-redemption-module__redemption-component__paused__copy'
  }, PausedAccCopy === null || PausedAccCopy === void 0 ? void 0 : PausedAccCopy.value)), moduleType === 'no-rewards' && /*#__PURE__*/React.createElement("div", {
    className: 'cb-mobile-pay-reward-redemption-module__redemption-component__no-rewards'
  }, /*#__PURE__*/React.createElement("span", {
    className: 'cb-mobile-pay-reward-redemption-module__redemption-component__no-rewards__copy'
  }, NoRewardsAvailable === null || NoRewardsAvailable === void 0 ? void 0 : NoRewardsAvailable.value)), moduleType === 'no-eligible-rewards' && /*#__PURE__*/React.createElement("div", {
    className: 'cb-mobile-pay-reward-redemption-module__redemption-component__no-rewards'
  }, /*#__PURE__*/React.createElement("span", {
    className: 'cb-mobile-pay-reward-redemption-module__redemption-component__no-rewards__copy'
  }, NoEligibleRewards === null || NoEligibleRewards === void 0 ? void 0 : NoEligibleRewards.value)), moduleType === 'redeem' ? /*#__PURE__*/React.createElement("div", {
    className: 'cb-mobile-pay-reward-redemption-module__redemption-component__redeem'
  }, /*#__PURE__*/React.createElement(Button, {
    disabled: isSubmitting,
    className: 'cb-button-primary',
    onClick: function onClick() {
      setShowOverlay(true);
      handleRedeemClick();
    }
  }, (RedeemButton === null || RedeemButton === void 0 ? void 0 : RedeemButton.value) || '')) : null, moduleType === 'recommended' && /*#__PURE__*/React.createElement("div", {
    className: 'cb-mobile-pay-reward-redemption-module__redemption-component__recommended'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'cb-mobile-pay-reward-redemption-module__redemption-component__recommended__box',
    onClick: handleReset
  }, /*#__PURE__*/React.createElement("span", {
    className: 'cb-mobile-pay-reward-redemption-module__redemption-component__recommended__header'
  }, RecommendedRewardsHeader === null || RecommendedRewardsHeader === void 0 ? void 0 : RecommendedRewardsHeader.value), /*#__PURE__*/React.createElement("span", {
    className: 'cb-mobile-pay-reward-redemption-module__redemption-component__recommended__list'
  }, rewardsList)), /*#__PURE__*/React.createElement("span", {
    className: 'cb-mobile-pay-reward-redemption-module__redemption-component__recommended__customize-link',
    onClick: handleCustomizeLink
  }, (RewardsLinkLabel === null || RewardsLinkLabel === void 0 ? void 0 : RewardsLinkLabel.value) || '')), moduleType === 'custom' && /*#__PURE__*/React.createElement("div", {
    className: 'cb-mobile-pay-reward-redemption-module__redemption-component__customized'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'cb-mobile-pay-reward-redemption-module__redemption-component__customized__box',
    onClick: handleReset
  }, /*#__PURE__*/React.createElement("span", {
    className: 'cb-mobile-pay-reward-redemption-module__redemption-component__customized__header'
  }, AppliedRewardsHeader === null || AppliedRewardsHeader === void 0 ? void 0 : AppliedRewardsHeader.value), /*#__PURE__*/React.createElement("span", {
    className: 'cb-mobile-pay-reward-redemption-module__redemption-component__customized__list'
  }, rewardsList)), /*#__PURE__*/React.createElement("span", {
    className: 'cb-mobile-pay-reward-redemption-module__redemption-component__customized__customize-link',
    onClick: handleCustomizeLink
  }, RewardsLinkLabel === null || RewardsLinkLabel === void 0 ? void 0 : RewardsLinkLabel.value))) : null)));
};

var rewardsOperations = rewardsDuck.operations;
var mobilePayOperations = mobilepayDuck.operations;

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    //Get user bonus rewards
    getBonusRewards: function getBonusRewards(releaseRedemptionEngineV2) {
      return dispatch(rewardsOperations.handleGetBonusRewards(releaseRedemptionEngineV2));
    },
    //Get user peg points
    getPegPoints: function getPegPoints(email, releaseRedemptionEngineV2) {
      return dispatch(rewardsOperations.handleGetPegPoints(email, releaseRedemptionEngineV2));
    },
    //Call to redemption engine to get the discounts
    rewardsRedemptionMobilePay: function rewardsRedemptionMobilePay(bonusRewards, pegPoints, type, redeemRetailItemsFlag, releaseRedemptionEngineV2) {
      return dispatch(rewardsOperations.handleRewardsRedemptionMobilePay(bonusRewards, pegPoints, type, redeemRetailItemsFlag, releaseRedemptionEngineV2));
    },
    redeemRewards: function redeemRewards(type, isMobilePay, redeemRetailItemsFlag, releaseRedemptionEngineV2) {
      return dispatch(rewardsOperations.handleRedeemRewards(type, isMobilePay, redeemRetailItemsFlag, releaseRedemptionEngineV2));
    },
    storeRedeemedRewards: function storeRedeemedRewards(data) {
      return dispatch(rewardsOperations.redeemRewardsAction(data));
    },
    getMenuItemPegPoints: function getMenuItemPegPoints(productChainIds) {
      return dispatch(rewardsOperations.handleGetMenuItemPegPoints(productChainIds, true));
    },
    orderValidate: function orderValidate() {
      return dispatch(mobilePayOperations.handleOrderValidate());
    },
    resetRewardsRedemptionModule: function resetRewardsRedemptionModule() {
      return dispatch(rewardsOperations.resetRewardsRedemptionModule());
    },
    resetCheck: function resetCheck() {
      return dispatch(mobilePayOperations.resetCheck());
    }
  };
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    rewardsState: state.rewards,
    account: state.account,
    mobilepay: state.mobilepay
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MPRewardRedemptionModule);